import UserProfileName from "@web-src/features/users/components/UserProfileName";
import { FC, ReactNode } from "react";
import { useTranslations } from "@jugl-web/utils";
import { MENTIONS_ALL_ID } from "@jugl-web/utils/consts";
import { ChatMessageBodyToken } from "@web-src/modules/chats/types";

type MessageTokensDisplayProps = {
  tokens: ChatMessageBodyToken[];
  isGroupInfo?: boolean;
};

export const MessageTokensDisplay: FC<MessageTokensDisplayProps> = ({
  tokens,
  isGroupInfo,
}) => {
  const { t } = useTranslations();

  const renderMentionLike = (content: ReactNode) => {
    if (isGroupInfo) {
      return content;
    }
    return <span className="text-dark font-medium">@{content}</span>;
  };

  if (!tokens?.length) {
    return t({
      id: "chats-page.unknown-message",
      defaultMessage: "Unknown message",
    });
  }
  return (
    <>
      {tokens.map((item, idx) => (
        // TODO: make component
        <span key={item.id}>
          {(() => {
            if (item.type === "userName") {
              return renderMentionLike(
                <UserProfileName userId={item.rawString} suffix={item.suffix} />
              );
            }
            if (item.type === "mention") {
              return renderMentionLike(
                item.value === MENTIONS_ALL_ID
                  ? t({
                      id: "common.all",
                      defaultMessage: "All",
                    })
                  : item.humanizedString || item.rawString
              );
            }
            return item.humanizedString || item.rawString || "";
          })()}
          {idx !== tokens.length ? " " : ""}
        </span>
      ))}
    </>
  );
};
